import { render, staticRenderFns } from "./MyProfileUpdate.vue?vue&type=template&id=cf316176&scoped=true"
import script from "./MyProfileUpdate.vue?vue&type=script&lang=js"
export * from "./MyProfileUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf316176",
  null
  
)

export default component.exports